<template>
  <b-card no-body>
    <b-card-body>
      <b-card bg-variant="light">
        <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records" :fields="this.tableFields"
          :hover="true" show-empty @row-dblclicked="moduloList">

          <template #empty>
            <p>Nenhum registro encontrado</p>
          </template>


          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
        </b-table>
        <b-row style="margin-top: 12px" v-if="records && records.length > 0">
          <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de {{
              totalPage }} -
              {{ total }} registros</b-col>
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
              <b-form-select size="sm" v-model="perPage" @change="() => this.load()" :options="perPageOptions">
              </b-form-select>
            </b-col>
          </b-col>
          <b-col cols="6">
            <div class="d-flex justify-content-end align-items-end">
              <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                :total-rows="total"></b-pagination>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-card-body>
  </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import { ListResourceMixin } from "@/core/mixins/resource";

export default {

  components: {

  },

  props: {
    onDblClickUsuarioModulo: Function,
  },

  data() {
    return {
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      filtro: "",
      showModal: false,
      form: {
        descricao: "",

        sistema: "",
      },
    };
  },
  mixins: [ListResourceMixin],
  beforeMount() {
    this.$service = new ResourceService(`/api/sgu/sistemas/0/modulos`);
  },
  mounted() {
    this.load();
  },
  watch: {
    page() {
      this.load();
    },
  },
  computed: {
    tableFields() {
      return [
        {
          key: "descricao",
          label: "Descrição",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
        {
          key: "sistema.nome",
          label: "Sistema",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
      ];
    },
  },
  methods: {
    moduloList(item){
      this.$emit("onselect", item);
    },
    async load() {

      this.busy = true
      await this.$loadResource({
        size: this.perPage,
        page: this.page,
        filter: this.filtro,
      });
    },

    async visualizarResource() {
      this.showModal = true;
    },

    async usuarioModuloSelect(item) {
      this.$emit("onDblClickUsuarioModulo", item);
      await this.$bvModal.show(this.id);
    },

    async buscarModulos() {
      return await this.$serviceModulo.findAll({});
    },

    async buscarModuloController() {
      const result = await this.$service.findAll({});
      this.form.modulo = result.data.content;
    },

    async alteraSituacao(item) {
      const { status } = await this.$service.alteraSituacao(item);
      if (status == 200) {
        this.$notify({
          type: "success",
          message: `Registro ${item.situacao ? "Ativado" : "Desativado"
            } com sucesso!`,
        });
      } else {
        this.$notify({
          type: "danger",
          message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
            } o registro!`,
        });
        item.situacao = !item.situacao;
      }
    },
  },
};
</script>
